import React, { useState, useMemo, useEffect } from 'react';
import axios from 'axios';
import { useInView } from "react-intersection-observer";
import config from '../../../settings/config.json';
import { Button, Form, Input, Space, Upload, Skeleton, notification } from 'antd';
import { UploadOutlined } from '@ant-design/icons';

import { Alert } from 'react-bootstrap';
import logo from '../../../assets/img/logo.png';

const { Dragger } = Upload;
const text = <span><i className="fa-solid fa-triangle-exclamation text-warning"></i> Şeir və ya qəzəlinizi səsləndirilməsi üçün bu qaydalara riayət etməniz vacibdir 1.göstərilən ünvana 1 şəkil və latın qrafikası ilə yazdıqınız şeir, word sənədi kimi göndərilməlidir. 2.Ekrandan çəkilmiş (screen) mətn qəbul olunmur. 3.elektron ünvanımıza materialı göndərdikdə,sizə avtobildiriş göndərilməlidir.Texniki problemlər yvbatından göndərilmədiyi halda,xahiş olunur digər ünvana göndərəsiniz.</span>;
const layout = {
  labelCol: {
    span: 8,
  },
  wrapperCol: {
    span: 16,
  },
};
const tailLayout = {
  wrapperCol: {
    offset: 8,
    span: 16,
  },
};
const tailLayoutM = {
  wrapperCol: {
    offset: 6,
    span: 16,
  },
};

function Home_Messages() {
  const [form] = Form.useForm();
  const [image, setImage] = useState([]);
  const [arrow, setArrow] = useState('Show');
  const [showAlert, setShowAlert] = useState(false);
  const [userName, setUserName] = useState('');
  const [settings, setSettings] = useState(null);
  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`/api/settings`);
        setSettings(response.data[0]);
      } catch (error) {
        console.error('ERROR:', error);
      }
    };

    fetchSettings();
    
    const interval = setInterval(fetchSettings, 5000);
    return () => clearInterval(interval);
  }, []);
  const mergedArrow = useMemo(() => {
    if (arrow === 'Hide') {
      return false;
    }
    if (arrow === 'Show') {
      return true;
    }
    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  const onReset = () => {
    form.resetFields();
  };

  const handleSubmit = async (values) => {
    const formData = new FormData();
    formData.append('name', values.name);
    formData.append('email', values.email);
    formData.append('phone', values.phone);
    formData.append('message', values.message);

    if (values.upload && values.upload.fileList.length > 0) {
      formData.append('file', values.upload.fileList[0].originFileObj);
    }

    try {
      const response = await axios.post(`/api/send`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });

      setImage([...image, { name: response.data.name, url: response.data.url }]);

      setUserName(values.name);
      setShowAlert(true);
      onReset();
    } catch (error) {
      console.error('Ошибка при отправке сообщения:', error);
      notification.error({
        message: 'Ошибка',
        description: 'Произошла ошибка при отправке сообщения.',
      });
    }
  };

  return (
    <div className='Messages'>
      <div className='qw-pc'>
        <br /><br /><br id='message' /><br />
        <center>
          <div className={`divider ${inView ? "view" : "none"}`} ref={ref}></div>
        </center>
        <br /><br />
        <div className={`center-content ${inView ? "view" : "none"}`}>
          <div className='qw-tt'>
            <h1 className='title_about'>
              <span className='text-gradient'>SÖZÜNÜ</span> BİZƏ İNDİ GÖNDƏR <br />
              <p className='text-secondary text-sm'>
                E-mail : {settings?.client?.email ? settings?.client?.email : <Skeleton.Button active />} <br />
                Tel : {settings?.client?.phone ? settings?.client?.phone : <Skeleton.Button active />}
              </p>
              {showAlert && (
                <Alert variant="success" onClose={() => setShowAlert(false)} dismissible>
                  <span className='fs-5 regular alert-text'>
                  <img src={logo} width='50px' height='50px' />
                    <span className='mt-cc'>Hörmətli <span className='text-gradient-two bold'>{userName}</span> Sizin mesajınız uğurla göndərilmişdir.</span>
                  </span>
                </Alert>
              )}
            </h1>
          </div>
          <div className='about p-5'>
            <Form
              {...layout}
              form={form}
              name="control-hooks"
              onFinish={handleSubmit}
              style={{ maxWidth: 600 }}
            >
              <Form.Item
                name="name"
                label="Ad"
                rules={[{ required: true, message: '' }]}
              >
                <Input size="large" className='white-placeholder' placeholder={settings?.client?.homePage?.sendMsg?.placeholders?.name ? settings?.client?.homePage?.sendMsg?.placeholders?.name : 'Loading...'} />
              </Form.Item>
              <Form.Item
                name="email"
                label="Email"
                rules={[{ required: true, message: '' }]}
              >
                <Input size="large" className='white-placeholder' placeholder={settings?.client?.homePage?.sendMsg?.placeholders?.email ? settings?.client?.homePage?.sendMsg?.placeholders?.email : 'Loading...'} />
              </Form.Item>
              <Form.Item
                name="phone"
                label="Nömrə"
                rules={[{ required: true, message: '' }]}
              >
                <Input
                  style={{ width: '100%' }}
                  size="large"
                  className='white-placeholder'
                  placeholder={settings?.client?.homePage?.sendMsg?.placeholders?.phone ? settings?.client?.homePage?.sendMsg?.placeholders?.phone : 'Loading...'}
                />
              </Form.Item>
              <Form.Item
                name="message"
                label="Mesaj"
                rules={[{ required: true, message: '' }]}
              >
                <Input.TextArea rows={6} size="large" className='white-placeholder' placeholder={settings?.client?.homePage?.sendMsg?.placeholders?.message ? settings?.client?.homePage?.sendMsg?.placeholders?.message : 'Loading...'} />
              </Form.Item>
              <Form.Item
                name="upload"
                label="Şəkil / Word"
                rules={[{ required: true, message: 'Şəkili yükləməyi unutdunuz!' }]}
              >
                <Dragger
                  name="upload"
                  beforeUpload={() => false}
                  maxCount={1}
                  listType="picture"
                  onChange={({ fileList }) => {
                    form.setFieldsValue({ upload: { fileList } });
                  }}
                >
                  <Button icon={<UploadOutlined />}>Upload</Button>
                </Dragger>
              </Form.Item>
              <Form.Item {...tailLayout}>
                <Space>
                  <Button type="primary" size="large" danger htmlType="submit">
                  {settings?.client?.homePage?.sendMsg?.buttons?.send ? settings?.client?.homePage?.sendMsg?.buttons?.send : 'Loading...'}
                  </Button>
                  <Button type="dashed" secondary size="large" htmlType="button" onClick={onReset}>
                  {settings?.client?.homePage?.sendMsg?.buttons?.clear ? settings?.client?.homePage?.sendMsg?.buttons?.clear : 'Loading...'}
                  </Button>
                </Space>
              </Form.Item>
            </Form>
          </div>
        </div>
      </div>
      <div className='qw-mobile'>
        <center><div className={`divider`}></div></center>
        <br /><br />
        <center>
          <h1 className='title_about-m' id='message2'>
            <span className='text-gradient title_about-m'>SÖZÜNÜ</span><br />BİZƏ İNDİ<br />GÖNDƏR<br />
          </h1>
        </center>
        <center>
          <p className='text-secondary text-sm fs-5'>
            E-mail : saningonderdiyin@gmail.com <br />
            Tel : +994 70 633 63 73
          </p>
        </center>
        <div className='p-5'>
          <Form
            {...layout}
            form={form}
            name="control-hooks"
            onFinish={handleSubmit}
            style={{ maxWidth: 600 }}
          >
            <Form.Item
              name="name"
              label="Ad"
              rules={[{ required: true, message: 'Please input your name!' }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="email"
              label="Email"
              rules={[{ required: true, message: 'Please input your email!' }]}
            >
              <Input size="large" />
            </Form.Item>
            <Form.Item
              name="phone"
              label="Nömrə"
              rules={[{ required: true, message: 'Please input your phone number!' }]}
            >
              <Input
                style={{ width: '100%' }}
                size="large"
              />
            </Form.Item>
            <Form.Item
              name="message"
              label="Mesaj"
              rules={[{ required: true, message: 'Please input your message!' }]}
            >
              <Input.TextArea rows={6} size="large" />
            </Form.Item>
            <Form.Item
              name="upload"
              label="Şəkil / Word"
              rules={[{ required: true }]}
            >
              <Dragger
                name="upload"
                beforeUpload={() => false}
                maxCount={1}
                listType="picture"
                onChange={({ fileList }) => {
                  form.setFieldsValue({ upload: { fileList } });
                }}
              >
                <Button icon={<UploadOutlined />}>Upload</Button>
              </Dragger>
            </Form.Item>
            <Form.Item {...tailLayoutM}>
              <Space>
                <Button type="primary" size="large" danger htmlType="submit">
                  Göndər
                </Button>
                <Button type="dashed" secondary size="large" htmlType="button" onClick={onReset}>
                  Sil
                </Button>
              </Space>
            </Form.Item>
          </Form>
        </div>
      </div>
    </div>
  );
}

export default Home_Messages;